module.exports = __webpack_public_path__ + "static/media/icon_phone.6d57b0f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_phone.svg
// module id = 708
// module chunks = 0